import { useTranslation } from "react-i18next";

export function AuthLoadingScreen() {
  const { t } = useTranslation("auth");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-6">
        {/* Logo/Brand */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-foreground">Salon Dashboard</h1>
        </div>

        {/* Loading spinner */}
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
        </div>

        {/* Loading message */}
        <div className="space-y-2">
          <p className="text-lg font-medium text-foreground">{t("initializing.message")}</p>
          <p className="text-sm text-muted-foreground">{t("initializing.description")}</p>
        </div>

        {/* Progress dots */}
        <div className="flex justify-center space-x-1">
          <div className="w-2 h-2 bg-primary/30 rounded-full animate-pulse" />
          <div className="w-2 h-2 bg-primary/50 rounded-full animate-pulse [animation-delay:0.2s]" />
          <div className="w-2 h-2 bg-primary/70 rounded-full animate-pulse [animation-delay:0.4s]" />
        </div>
      </div>
    </div>
  );
}
